import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container className="text-center mt-5">
      <div style={{ maxWidth: "600px", margin: "auto" }}>
        <img
          src="/images/404.svg"
          alt="404 Not Found"
          style={{ width: "100%", maxWidth: "300px", marginBottom: "20px" }}
        />
        <h2 className="text-danger fw-bold">Oops! Page not found</h2>
        <p className="text-muted">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <p className="fw-semibold text-primary">
          Redirecting you to the home page...
        </p>
        <Button variant="outline-primary" onClick={() => navigate("/")}>
          Go to Home Now
        </Button>
      </div>
    </Container>
  );
};

export default NotFound;
